import React from 'react';

export const AppSplash = () => {
  return <div> . . . </div>;
};
